<template>
  <div class="users-view-page">
    <b-card no-body class="user-view-card mb-2" v-if="studentLoading">
      <b-card-body
        class="p-4 d-flex align-items-center justify-content-center"
        style="min-height: 400px"
      >
        <div class="text-center w-100">
          <div
            class="skeleton-loader mx-auto mb-2"
            style="width: 140px; height: 140px; border-radius: 50%"
          ></div>
          <div
            class="skeleton-loader mx-auto mb-1"
            style="width: 200px; height: 30px"
          ></div>
          <div
            class="skeleton-loader mx-auto mb-1"
            style="width: 150px; height: 20px"
          ></div>
        </div>
      </b-card-body>
    </b-card>

    <b-card no-body class="user-view-card mb-2" v-else-if="!showError && myObj.id">
      <b-card-body class="p-0">
        <div class="user-view-header">
          <b-button
            variant="light"
            size="sm"
            class="back-btn shadow-sm font-weight-bold text-primary"
            @click="goBack"
          >
            <feather-icon icon="ArrowLeftIcon" class="mr-50" />
            {{ $t("Back") }}
          </b-button>
        </div>
        <b-row class="m-0">
          <b-col
            cols="12"
            lg="4"
            xl="3"
            class="profile-sidebar border-right p-0 bg-white position-relative"
          >
            <user-view-user-info-card
              :user-data="myObj"
              :item="item"
              :campuses="campuses"
              :showLedger="settingsValues.showLedger"
              :showDeposit="settingsValues.showDeposit"
              :getCampus="getCampus"
            />
          </b-col>

          <b-col cols="12" lg="8" xl="9" class="p-3 p-md-3 px-2 py-2 user-plan-tabs-col">
            <div class="user-plan-tabs-shell">
              <user-view-user-plan-card
                :dues="dues"
                :history="history"
                :duesTotal="duesTotal"
                :user-data="myObj"
                :gridLoading="gridLoading"
                :showReceive="showReceive"
                :campuses="campuses"
                :getCampus="getCampus"
                @load-dues="loadData()"
                @update-settings="updateSettings"
              />
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body class="user-view-card mb-2 text-center" v-else-if="showError">
      <b-card-body class="p-5">
        <feather-icon icon="AlertCircleIcon" size="50" class="text-warning mb-2" />
        <h3 class="text-warning font-weight-bolder">{{ $t("User Not Found") }}</h3>
        <p class="text-muted mb-2">{{ $t("No user found with this id.") }}</p>
        <b-button variant="primary" class="back-btn" @click="goBack">
          {{ $t("Back") }}
        </b-button>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted } from "@vue/composition-api";
import { BRow, BCol, BCard, BCardBody, BSpinner, BButton } from "bootstrap-vue";
import userStoreModule from "../userStoreModule";
import UserViewUserInfoCard from "./UserViewUserInfoCard.vue";
import UserViewUserPlanCard from "./UserViewUserPlanCard.vue";
import { mapActions } from "vuex";

export default {
  props: ["item"],
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BSpinner,
    BButton,
    UserViewUserInfoCard,
    UserViewUserPlanCard,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from && from.name == "student-enrolled") {
        vm.showReceive = true;
      }
    });
  },
  created() {
    this.LoadStudent();
    if (this.reportDomain === "myskoolhpgs") {
      this.LoadCampuses();
    }
  },
  data() {
    return {
      myObj: {},
      gridLoading: false,
      studentLoading: false,
      dues: [],
      history: [],
      duesTotal: 0,
      showError: false,
      campuses: [],
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      showReceive: false,
      settingsValues: {
        showLedger: false,
        showDeposit: false,
      },
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    goBack() {
      if (window.history.length > 1) {
        this.$store.commit("setIsBack", true);
        this.$router.go(-1);
      } else {
        this.$router.push({ name: "manage-studentgrid" });
      }
    },

    getCampus(id) {
      let obj = this.campuses.find((el) => el.id == id);
      return obj ? obj.branch : "-";
    },
    updateSettings(obj) {
      this.settingsValues = { ...obj };
    },
    async LoadCampuses() {
      var obj = {
        url:
          this.$store.state.domain +
          "campuses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.campuses = await this.get(obj);
    },
    async LoadStudent() {
      this.studentLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Students/getStudent?db=" +
          this.$store.state.userData.db +
          "&sID=" +
          this.$route.params.id,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);

      if (res == "NotFound" || !res) {
        this.showError = true;
      } else {
        this.myObj = res;
        this.loadData();
      }
      this.studentLoading = false;
    },
    async loadData() {
      this.gridLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "Fees/GetStudentFeesRecord?db=" +
          this.$store.state.userData.db +
          "&campusID=" +
          this.myObj.campusID +
          "&sID=" +
          this.myObj.id,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      if (res === "No record found") {
        this.gridLoading = false;
        this.dues = [];
        this.history = [];
        this.duesTotal = 0;
      } else {
        this.dues = res[0].dues;
        this.history = res[0].history;
        this.duesTotal = res[0].duesTotal;

        this.gridLoading = false;
      }
    },
  },
  setup() {
    const userData = ref(null);

    const USER_APP_STORE_MODULE_NAME = "app-user";

    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    store
      .dispatch("app-user/fetchUser", { id: router.currentRoute.params.id })
      .then((response) => {
        userData.value = response.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          userData.value = undefined;
        }
      });

    return {
      userData,
    };
  },
};
</script>

<style lang="scss" scoped>
.users-view-page {
  animation: slideUpFade 0.45s ease both;
  max-width: 100%;
  overflow-x: hidden;
}

.user-view-card {
  background: #ffffff;
  border: 1px solid #ece8ff;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(115, 103, 240, 0.08);
  position: relative;
  overflow: visible;
}

.user-view-header {
  display: flex;
  align-items: center;
  padding: 0.9rem 1.25rem;
  background: linear-gradient(135deg, #f8f6ff 0%, #ffffff 100%);
  border-bottom: 1px solid #f0edff;
  border-radius: 20px 20px 0 0;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(
      ellipse at 8% 0%,
      rgba(124, 93, 250, 0.1) 0%,
      transparent 58%
    );
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    top: -28px;
    right: 8%;
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: rgba(157, 122, 255, 0.07);
    pointer-events: none;
  }

  .back-btn {
    position: relative;
    z-index: 1;
  }
}

.profile-sidebar {
  border-right: 1px solid #f0edff !important;
}

.back-btn {
  border-radius: 10px;
  padding: 8px 14px;
  transition: all 0.3s ease;
  background: #ffffff;
  color: #7c5dfa !important;
  border: 1px solid #e0d8ff;

  &:hover {
    background: linear-gradient(135deg, #7c5dfa 0%, #9d7aff 100%) !important;
    color: #ffffff !important;
    border-color: transparent;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(124, 93, 250, 0.2) !important;
  }
}

.user-plan-tabs-col {
  background: #fff;
  padding-top: 0.25rem !important;
}

.user-plan-tabs-shell {
  min-height: 320px;
}

.skeleton-loader {
  background: linear-gradient(90deg, #f3f0ff 25%, #ece8ff 50%, #f3f0ff 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

@keyframes slideUpFade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

::v-deep .user-info-inner {
  padding: 0;
}

::v-deep .user-info-inner .card,
::v-deep .user-plan-panel > .card {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

::v-deep .user-plan-tabs-shell .custom-nav-tabs {
  background: #f8f9fb;
  border: 1px solid #eef0f4;
  border-radius: 14px;
  padding: 0.35rem;
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  gap: 0.35rem;

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 4px;
  }

  .nav-item {
    flex: 0 0 auto;
    margin-bottom: 0;

    .nav-link {
      border: 1px solid transparent !important;
      color: #6b7280 !important;
      font-weight: 600;
      font-size: 0.84rem;
      padding: 0.5rem 0.95rem !important;
      margin-right: 0;
      border-radius: 10px !important;
      transition: all 0.2s ease;
      background: transparent !important;
      white-space: nowrap;
      display: inline-flex;
      align-items: center;
      gap: 0.35rem;
      cursor: pointer;
      user-select: none;

      &:hover {
        color: #7c5dfa !important;
        background: #ffffff !important;
      }

      &.active,
      &.custom-nav-active {
        color: #7c5dfa !important;
        background: #ffffff !important;
        border-color: #e0d8ff !important;
        font-weight: 700;
        box-shadow: 0 2px 10px rgba(124, 93, 250, 0.12) !important;
      }
    }
  }
}

::v-deep .user-plan-tabs-shell .user-plan-tab-panes {
  padding-top: 0.5rem;
  min-height: 120px;
}

::v-deep .user-plan-tabs-shell .tab-content {
  padding-top: 0.35rem;
}

::v-deep .user-plan-tabs-shell .content-panel {
  border: 1px solid #eef0f4 !important;
  border-radius: 14px !important;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04) !important;
  margin-bottom: 1rem;
  background: #ffffff !important;
  padding: 1.15rem;
}

::v-deep .user-plan-tabs-shell .card-title {
  color: #1f2937;
  font-weight: 700;
  font-size: 1rem;
}

@media (max-width: 991.98px) {
  .user-view-card {
    border-radius: 14px;
  }

  .user-view-header {
    padding: 0.75rem 1rem;
    border-radius: 14px 14px 0 0;
  }

  .profile-sidebar {
    border-right: none !important;
    border-bottom: 1px solid #f0edff;
  }

  .user-plan-tabs-col {
    padding: 0.75rem !important;
  }

  ::v-deep .user-plan-tabs-shell .content-panel {
    padding: 0.85rem !important;
  }
}

@media (max-width: 767.98px) {
  ::v-deep .user-plan-tabs-shell .custom-nav-tabs {
    margin-bottom: 0.65rem;
    padding: 0.3rem;
    border-radius: 12px;

    .nav-item .nav-link {
      padding: 0.45rem 0.7rem !important;
      font-size: 0.78rem;
    }
  }

  ::v-deep .user-plan-tabs-shell .content-panel {
    padding: 0.75rem !important;
    border-radius: 12px !important;
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 575.98px) {
  .user-view-card {
    border-radius: 10px;
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .user-view-header {
    padding: 0.65rem 0.75rem;
    border-radius: 10px 10px 0 0;
  }

  .user-plan-tabs-col {
    padding: 0.5rem !important;
  }

  ::v-deep .user-plan-tabs-shell .custom-nav-tabs .nav-item .nav-link {
    padding: 0.4rem 0.55rem !important;
    font-size: 0.72rem;
  }
}
</style>
